module.exports = __webpack_public_path__ + "15cdae11d8f9fa7dbd6e0b1f2ab93fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgdab_c.png
// module id = 280
// module chunks = 3